import { createContext, useContext } from 'react';

export interface TourContextValue {
  /** True while the tour is on screen. */
  active: boolean;
  /** Start (or restart) the tour from the first step. */
  replay: () => void;
}

export const TourContext = createContext<TourContextValue | null>(null);

/** Tour controls; a no-op outside <TourProvider> so components stay renderable in isolation (unit tests). */
export function useTour(): TourContextValue {
  return useContext(TourContext) ?? NOOP;
}

const NOOP: TourContextValue = { active: false, replay: () => {} };
